import { Category, PageInfo, Post, } from 'generated-graphql';
import { CATEGORIES } from 'gql/categories';
import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global';
import React from 'react';
import get from 'lodash/get';
import { FEATURED_POSTS, getPosts } from 'gql/posts';
import ResourcesPage from '@/components/ResourcesPage/ResourcesPage';
import { first } from 'lodash';


const ResourceList = ({
  pageData,
  categories,
  pageInfo,
  featured
}: {
  pageData: Post[];
  categories: Category[];
  pageInfo: PageInfo,
  featured: Post[];
}) => {
  return <ResourcesPage pageData={pageData} categories={categories} pageInfo={pageInfo} featured={featured} />
};

export default ResourceList;


export async function getStaticProps() {
  const apolloClient = initializeApollo();

  const categoriesQuery = await apolloClient.query({
    query: CATEGORIES,
    variables: { names: ['Brands', 'Series'] },
  });

  const categories = get(categoriesQuery, 'data.categories.nodes', []);

  const results = await apolloClient.query({
    query: getPosts(
      [],
    ), variables: {
      after: '',
      first: 11,
    }
  });


  const featured = await apolloClient.query({
    query: getPosts(
      ["Featured"]
    ), variables: {
      first: 3,
    }
  });
  const pageProps = {
    pageInfo: results.data?.posts?.pageInfo,
    pageData: results.data?.posts?.nodes || [],
    featured: featured.data?.posts?.nodes || [],
    categories,
  };

  return await getGlobalData(pageProps, apolloClient);
};